import { BaseService } from "./BaseService";

export class PlaylistService extends BaseService {
  getPlaylists(isShared,isTag) {
      return this.request(`api/Playlist/GetPlaylists/${isShared ?? false}/${isTag ?? false}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "GET",
    });
  }

  getPlaylistsPrograms(idPlaylist, top) {
    return this.request(`api/Playlist/GetPlaylistsPrograms/${idPlaylist}/${top}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "GET",
    });
  }

  getPlaylistsByProgram(idProgram) {
    return this.request(`api/Playlist/GetPlaylistsByProgram/${idProgram}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "GET",
    });
  }

  getPlaylistsCountByProgram(idProgram) {
    return this.request(`api/Playlist/GetPlaylistsCountByProgram/${idProgram}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "GET",
    });
  }

  addPlaylist(playlist) {
    return this.request("api/Playlist/AddPlaylist", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify(playlist),
    });
  }

  savePlaylist(playlist) {
    return this.request("api/Playlist/SavePlaylist", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "PUT",
      body: JSON.stringify(playlist),
    });
  }

  duplicatePlaylist(id) {
    return this.request(`api/Playlist/DuplicatePlaylist/${id}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "PUT",
    });
  }

  addProgramsToPlaylist(programsPlaylist) {
    return this.request("api/Playlist/AddProgramsToPlaylist", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "PUT",
      body: JSON.stringify(programsPlaylist),
    });
  }

  removeProgramsToPlaylist(programsPlaylist) {
    return this.request("api/Playlist/RemoveProgramsToPlaylist", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "PUT",
      body: JSON.stringify(programsPlaylist),
    });
  }

  deletePlaylist(id) {
    return this.request(`api/Playlist/DeletePlaylist/${id}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "DELETE",
    });
  }

  getUnseenSharedPlaylistCount(id) {
    return this.request("api/Playlist/GetUnseenSharedPlaylistCount", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "GET",
    });
  }

  markSharedPlaylistsAsSeen(id) {
    return this.request("api/Playlist/MarkSharedPlaylistsAsSeen", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "POST",
    });
  }

  linkMultipleSharedPlaylist(id, idUsers) {
    return this.request(`api/Playlist/LinkMultipleSharedPlaylist/${id}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "PUT",
      body: JSON.stringify(idUsers),
    });
  }

  unlinkSharedPlaylist(id) {
    return this.request(`api/Playlist/UnlinkSharedPlaylist/${id}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "DELETE",
    });
  }

  unlinkMultipleSharedPlaylist(id, idUsers) {
    return this.request(`api/Playlist/UnlinkMultipleSharedPlaylist/${id}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "PUT",
      body: JSON.stringify(idUsers),
    });
  }

  getSharedPlaylistUsers(idPlaylist, isShared) {
    return this.request(`api/Playlist/GetSharedPlaylistUsers/${idPlaylist}/${isShared ?? ""}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "GET",
    });
  }

  addPlaylistFolder(playlistFolder) {
    return this.request("api/Playlist/AddPlaylistFolder", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify(playlistFolder),
    });
  }

  savePlaylistFolder(playlistFolder) {
    return this.request("api/Playlist/SavePlaylistFolder", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "PUT",
      body: JSON.stringify(playlistFolder),
    });
  }

  deletePlaylistFolder(id) {
    return this.request(`api/Playlist/DeletePlaylistFolder/${id}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "DELETE",
    });
  }

  getSortablePlaylists() {
    return this.request("api/Playlist/GetSortablePlaylists", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "GET",
    });
  }

  setSortablePlaylists(sortableList) {
    return this.request("api/Playlist/SetSortablePlaylists", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "PUT",
      body: JSON.stringify(sortableList),
    });
  }
}

const playlistService = new PlaylistService();

export default playlistService;
